// biome-ignore lint/style/noRestrictedImports: encapsulation
import { isShallowEqual as isShallowEqual_ } from "remeda";

import type { NeverFunc } from "./_never-func";
import { unpurry } from "./_unpurry";

export const isShallowEqual = unpurry(isShallowEqual_, 2) as typeof isShallowEqual_ & NeverFunc;
